import { render, staticRenderFns } from "./ConfirmEmailCode.vue?vue&type=template&id=eb2cdfd0"
import script from "./ConfirmEmailCode.vue?vue&type=script&lang=js"
export * from "./ConfirmEmailCode.vue?vue&type=script&lang=js"
import style0 from "./ConfirmEmailCode.vue?vue&type=style&index=0&id=eb2cdfd0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb2cdfd0')) {
      api.createRecord('eb2cdfd0', component.options)
    } else {
      api.reload('eb2cdfd0', component.options)
    }
    module.hot.accept("./ConfirmEmailCode.vue?vue&type=template&id=eb2cdfd0", function () {
      api.rerender('eb2cdfd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/account/ConfirmEmailCode.vue"
export default component.exports